import Table2 from "../../../../../components/Table2";
import { useMonitoreoPersonalStore } from "../../../../../store/monitoreoPersonal";
import { tableData } from "./tableData";


const TablaInteraccionesBackOfficeUnDia = () => {

    const { interaccionesUnDia } = useMonitoreoPersonalStore();
    return (
        <>
            <Table2
                height={"450px"}
                data={tableData(interaccionesUnDia?.interacciones_backoffice)}
            />
        </>
    );
}
export default TablaInteraccionesBackOfficeUnDia;